import Projects from "../../components/Project/Projects";

export default function AdminProjects() {
  return (
    <Projects userRole={"Admin"} viewType={"projects"} />
  );
}
